import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import accountService from "../../../services/accountService";
import authService from "../../../services/authService";
import Table from "../../../components/common/Table";
import Pagination from "../../../components/common/Pagination";
import moment from "moment";

const AccountsTable = ({ data, columns, setData, tableOptions, onChange }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const user = authService.getCurrentUser();
  const role =
    user["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];

  useEffect(() => {
    let mounted = true;

    const fetchAccounts = async () => {
      setIsLoading(true);

      const response = await accountService.getAccountsAsync(tableOptions);
      const { result, page, total_count } = response;

      const accounts = result.map((item) => {
        const { account_status: status } = item;
        const { bg_color } = accountService.getAccountStatusProperties(status);
        const status_class = `rounded-full h-2 w-2 flex items-center justify-center ${bg_color}`;

        const name = (
          <Link to={`/accounts/${item.id}`}>
            <span className="text-gray-500 hover:text-blue-400">
              {item.first_name + " " + item.last_name}
            </span>
          </Link>
        );

        const account_status = (
          <div className="flex items-center">
            <div className={status_class}></div>
            <span className="ml-3">{item.account_status_type}</span>
          </div>
        );

        const contact = (
          <div>
            <p className="text-gray-500 mb-1">{item.email}</p>
            <span className="text-xs">{item.phone_number}</span>
          </div>
        );

        item["name"] = name;
        item["account_status"] = account_status;
        item["email"] = contact;
        item["created_on"] = moment(item.created_on).format("LL");

        return item;
      });

      if (mounted) {
        setData(accounts);
        setCurrentPage(page);
        setTotalCount(total_count);
        setIsLoading(false);
      }
    };

    fetchAccounts();

    return () => {
      mounted = false;
    };
  }, [tableOptions, setData, role]);

  const handleSort = (sort_column) => {
    const options = { ...tableOptions };
    options.sort_column = sort_column;
    onChange(options);
  };

  const handlePageChange = (page) => {
    const options = { ...tableOptions };
    options.current_page = page;
    onChange(options);
  };

  return (
    <div className="overflow-auto lg:overflow-visible">
      <Table
        data={data}
        columns={columns}
        sortColumn={tableOptions.sort_column}
        onSort={handleSort}
        isLoading={isLoading}
      />
      <Pagination
        itemsCount={totalCount}
        currentPage={currentPage}
        pageSize={tableOptions.page_size}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default AccountsTable;
